import withHttp from '@/config/withHttp';
var baseURL = '/judgeagent';
/* *************** 案件管理相关接口 ******************* */

var apis = {
  // 获取用户所在法院的代字
  court: {
    url: '/case/court',
    method: 'get'
  },
  // 分页查询案件信息
  getCase: {
    url: '/case/search',
    method: 'post'
  },
  // 获取案件代字
  caseCodes: {
    url: '/case/caseCodes',
    method: 'get'
  },
  // 案件类别
  caseTypes: {
    url: '/case/caseTypes',
    method: 'get'
  },
  // 获取案件类别完整树，适用于非默认案号的情况
  caseTypeTree: {
    url: '/case/caseTypeTree',
    method: 'get'
  },
  // 案由异步树
  caseActionByParentId: {
    url: '/case/caseActionByParentId',
    method: 'get'
  },
  // 案由同步树
  caseActionTree: {
    url: '/case/caseActionTree',
    method: 'post'
  },
  // 案由同步树(无叶子节点)
  caseActionTreeNoLeaf: {
    url: '/case/findCaseActionTreeByNameNoLeaf',
    method: 'post'
  },
  // 案由子项查询
  caseSubItem: {
    url: '/case/queryListByLikePath',
    method: 'post'
  },
  // 异步获取审判程序
  trialProgramTree: {
    url: '/case/trialProgramList',
    method: 'get'
  },
  // 获取承办部门同步树
  deptByIndexCode: {
    url: '/dept/deptByIndexCode',
    method: 'get'
  },
  // 获取部门下成员（承办人）
  usersInDept: {
    url: '/dept/userList',
    method: 'get'
  },
  // 异步查询诉讼地位树
  litStatusTree: {
    url: '/litStatus/getLitStatusTree',
    method: 'get'
  },
  // 新建案件
  saveCase: {
    url: '/case/save',
    method: 'post'
  },
  // 修改案件
  updateCase: {
    url: '/case/update',
    method: 'post'
  },
  // 删除案件
  deleteCase: {
    url: '/case/delete',
    method: 'post'
  },
  // 案件详情
  caseDetail: {
    url: '/case/detail',
    method: 'get'
  },
  // 获取庭审记录
  trialRecords: {
    url: '/case/trialRecords',
    method: 'get'
  },
  // 获取庭审笔录记录
  trialNote: {
    url: '/schedule/checkNoteByScheduleId',
    method: 'get'
  },
  // 获取庭审回放
  trialVideo: {
    url: '/schedule/trialVideo',
    method: 'get'
  },
  // 根据案件id查询排期
  nearestSchedule: {
    url: '/case/nearestSchedule',
    method: 'get'
  },
  // 更新庭审状态
  changeTrialStatus: {
    url: '/case/reTrial',
    method: 'post'
  }
};
export default withHttp(apis, baseURL);